module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrap",
    attrs: {
      "id": "wrap"
    }
  }, [_c('component-header'), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pager home-bg"
  }, [_c('div', {}, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "margin-top": "8em",
      "text-align": "center"
    }
  }, [_c('h2', {
    staticClass: "hero-intro"
  }, [_vm._v("Stanel World")]), _vm._v(" "), _c('h3', {
    staticClass: "hero-text"
  }, [_vm._v("Get More Value")]), _vm._v(" "), _c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/assets/images/shopping-bag1.png",
      "width": "530",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "margin-top": "2em",
      "text-align": "center"
    }
  }, [_c('a', {
    staticClass: "btn sp-button-1 btn-clear",
    staticStyle: {
      "margin": "1em"
    },
    attrs: {
      "href": "/timeline"
    }
  }, [_vm._v("Welcome")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-555a7296"}!./src/pages/Home/template.html
// module id = 261
// module chunks = 0